import Link from 'next/link'

interface Props {
  slice: any
}
const Acknowledgements = ({ slice }: Props) => {
  const { items } = slice
  const { primary } = slice

  const firstLink = primary?.firstLink
  const firstLinkText = primary?.firstLinkText
  const firstTitle = primary?.firstTitle

  const secondLink = primary?.secondLink
  const secondLinkText = primary?.secondLinkText
  const secondTitle = primary?.secondTitle

  return (
    <div className="wrapper bg-ui-light-grey pt-10 pb-16 lg:pb-30">
      <div className="flex gap-[29px] lg:gap-[37px]">
        <div className="label-bold flex flex-col gap-3 ">
          {firstTitle && <div>{firstTitle}</div>}
          {secondTitle && <div>{secondTitle}</div>}
        </div>
        <div className="label flex flex-col gap-6 underline">
          <div className="label flex flex-col gap-3 underline">
            {firstLink && (
              <div className="hover:opacity-75">
                <Link href={firstLink} target="_blank" rel="noreferrer">

                  {firstLinkText}

                </Link>
              </div>
            )}
            {secondLink && (
              <div className="hover:opacity-75">
                <Link href={secondLink} target="_blank" rel="noreferrer">

                  {secondLinkText}

                </Link>
              </div>
            )}
          </div>
          <div className="label flex flex-col gap-3 underline">
            {items && (
              <>
                {items.map((item: any, index: number) => {
                  return (
                    <div key={index} className="hover:opacity-75">
                      <Link href={item?.otherLink || '/'} target="_blank" rel="noreferrer">

                        {item?.otherLinkText}

                      </Link>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Acknowledgements
